export const waitlistPublicApiQueryKeys = {
  basicInfo: (orgSlug: string, tourSlug: string) =>
    ['waitlist', orgSlug, tourSlug, 'basicInfo'] as const,
};
